import React from 'react'

const CustomPopupDialog = (props) => {
    return (<div> 
      <dialog
        id='delete_dialog2'
        className='bottom-0 fixed flex h-full inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40'
        open
      >
        <span
          className='!w-max bg-white overflow-hidden relative rounded'
          style={{ boxShadow: '0 4px 14px #0003' }}
        >
         {props.component} 
            </span>
      </dialog>
         </div>)
   
    
};


export default CustomPopupDialog
